import React, { Component } from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import CountryIcon from '~/UI/CountryIcon/CountryIcon';

interface Props {
	group: UserProductGroup;
	style: string;
}

export default class GroupSelectModule extends Component<Props> {
	render() {
		const { group, style } = this.props;

		if (group.hasCzMaxPriceModule()) {
			return (
				<p>
					<strong className={style}>
						<CountryIcon code='CZ' size={18} /> Max Price
					</strong>
				</p>
			);
		}
		if (group.hasCzReimbursementModule()) {
			return (
				<p>
					<strong className={style}>
						<CountryIcon code='CZ' size={18} /> Reimbursement
					</strong>
				</p>
			);
		}
		if (group.hasSkMaxPriceModule()) {
			return (
				<p>
					<strong className={style}>
						<CountryIcon code='SK' size={18} /> Max Price
					</strong>
				</p>
			);
		}
		if (group.hasRoMaxPriceModule()) {
			return (
				<p>
					<strong className={style}>
						<CountryIcon code='RO' size={18} /> Max Price
					</strong>
				</p>
			);
		}
		return null;
	}
}
